import React from 'react'


export function TnFooter({ editSettings }) {
  return (
    <table id="tn-info">
    <tbody>
      <tr>
        <td className="editable" onClick={editSettings}>
            {/* <p className="small">
              <strong>That’s Nice, Paris</strong>
              <br />
              17 Rue Scribe
              <br />
              5th Floor
              <br />
              75009 Paris
              <br />
              France
            </p> */}

            <p className="small">
              <strong>That’s Nice LLC</strong>
              <br />
              89 Fifth Avenue
              <br />
              5th Floor
              <br />
              New York, NY 10003
              <br />
              USA
            </p>
 
        </td>
        <td>
          <p className="small">
            <strong>Research Services</strong>
            <br />
            Nice Insight
            <br />
            Pharma’s Almanac
            <br />
            FTE/PTE Research
          </p>
        </td>
        <td>
          <p className="small">
            <strong>Agency Services</strong>
            <br />
            Strategy
            <br />
            Brand
            <br />
            Creative
            <br />
            Digital & SEO
            <br />
            Social Media
            <br />
            Media & PR
          </p>
        </td>
        <td>
          <p className="small">
            <strong>Business Services</strong>
            <br />
            Nice Consulting
            <br />
            Nice Match
            <br />
          </p>
        </td>
        <td>
          <p className="small">
            <strong> Websites</strong>
            <br />
            www.thatsnice.com
            <br />
            www.pharmasalmanac.com
            <br />
            www.disamr.com
            <br />
            www.niceinsight.com
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  )
}

export function DisamrFooter({ editSettings }) {
    return (
        <table id="tn-info">
        <tbody>
          <tr>
            <td className="editable" onClick={editSettings}>

                <p className="small">
                  <strong>disAMR LLC</strong>
                  <br />
                  89 Fifth Avenue
                  <br />
                  5th Floor
                  <br />
                  New York, NY 10003
                  <br />
                  USA
                </p>
 
            </td>
            <td>
              <p className="small">
                <strong>Research Services</strong>
                <br />
                Qualitative Research
                <br />
                Quantitative Research
                <br />
                Pricing
                <br/>
                Thought Leadership
              </p>
            </td>
            <td>
              <p className="small">
                <strong>Agency Services</strong>
                <br />
                Brand Identity
                <br />
                Digital Campaigns
                <br />
                Events             
                <br />
                Media & PR
              </p>
            </td>
            <td>
              <p className="small">
                <strong>Consulting Services</strong>
                <br />
                Go-to-Market Strategy
                <br />
                M&A Fundraising
                <br />
                Business Planning
                <br />
                Due Diligence
                <br />
              </p>
            </td>
            <td>
              <p className="small">
                <strong> Websites</strong>
                <br />
                www.disamr.com
                <br />
                www.thatsnice.com
                <br />
                www.pharmasalmanac.com
                <br />
                www.niceinsight.com
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      )
}
